export default "__VITE_ASSET__4a803eaf__"